// Strip everything except digits from a WhatsApp number / country code so the
// stored value (and any wa.me link built from it) is valid. WhatsApp deep links
// (https://wa.me/<number>) require digits only — a leading "+" or spaces make
// the link dead. Example: "+965 1234 5678" -> "96512345678".
// Added for the 2026-06-11 client fix (WhatsApp dead-link issue).
export const digitsOnly = (v) => String(v ?? '').replace(/\D/g, '');

// Returns a shallow copy of a business-form payload with the WhatsApp country
// code and number sanitized to digits only. Leaves all other fields untouched
// (mobile/tel numbers keep their "+" since tel: links accept it).
export const sanitizeWhatsAppFields = (data) => {
  if (!data || typeof data !== 'object') return data;
  const out = { ...data };
  if ('whatsAppNumberCountryCode' in out)
    out.whatsAppNumberCountryCode = digitsOnly(out.whatsAppNumberCountryCode);
  if ('whatsAppNumber' in out) out.whatsAppNumber = digitsOnly(out.whatsAppNumber);
  return out;
};
